import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import OEMS from "../../assets/oems.jpg";
import AttachmentTwo from "../../assets/attachment2.jpg";
import SolutionsOne from "../../assets/solutions1.jpg";
import SolutionsTwo from "../../assets/solutions2.jpg";
import {
  GiPathDistance,
  GiHeavyThornyTriskelion,
  GiServerRack,
} from "react-icons/gi";
import { RxExclamationTriangle } from "react-icons/rx";
import { IoIosTimer } from "react-icons/io";
import { HiOutlinePuzzlePiece } from "react-icons/hi2";
import { ImCompass } from "react-icons/im";

const OEMs = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };

  return (
    <>
      <Helmet>
        <title>Medichy | OEMs</title>
        <meta
          name="description"
          content="Medichy is a modern digital medical and healthcare platform delivering reliable medical and healthcare solutions."
        />
      </Helmet>
      <TheOEM>
        <div className="contact-hero-section">
          <img src={OEMS} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h3>
              Partner with Medichy to scale your medical device manufacturing
              with precision and efficiency.
            </h3>
            <p>
              We provide OEMs with end-to-end solutions from concept to
              production, ensuring regulatory compliance, cost efficiency, and
              accelerated time-to-market.
            </p>
            <button className="btn-secondary" onClick={handleTalkToTeam}>
              TALK TO OUR TEAM
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="container">
          <div className="early-stage">
            <div className="section-header">
              <h3>Common challenges for OEMs in medtech</h3>
              <p className="section-subtitle">
                OEMs face unique challenges in scaling production while
                maintaining quality, compliance, and cost-effectiveness in a
                rapidly evolving market.
              </p>
            </div>

            <div className="imagery-container">
              <div className="imagery-image">
                <img src={AttachmentTwo} alt="imagery-img" />
                <div className="image-overlay"></div>
              </div>

              <div className="imagery-content">
                <div className="content-item">
                  <div className="icon-wrapper">
                    <GiPathDistance className="icon" />
                  </div>
                  <div className="item-text">
                    <h4>Complex regulatory compliance</h4>
                    <p>
                      Navigating FDA, CE, and other global regulatory
                      requirements while scaling production across markets.
                    </p>
                  </div>
                </div>

                <div className="content-item">
                  <div className="icon-wrapper">
                    <GiHeavyThornyTriskelion className="icon" />
                  </div>
                  <div className="item-text">
                    <h4>Production scalability issues</h4>
                    <p>
                      Difficulty scaling from pilot batches to full-scale
                      production while maintaining quality and cost targets.
                    </p>
                  </div>
                </div>

                <div className="content-item">
                  <div className="icon-wrapper">
                    <RxExclamationTriangle className="icon" />
                  </div>
                  <div className="item-text">
                    <h4>Supply chain vulnerabilities</h4>
                    <p>
                      Managing complex global supply chains with reliability and
                      quality assurance at every step.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="solutions-section">
            <div className="section-header">
              <h3>Solutions that accelerate OEM success</h3>
              <p className="section-subtitle">
                Our comprehensive solutions are designed to address the unique
                challenges faced by OEMs in the medical device industry.
              </p>
            </div>

            <div className="solutions-cards">
              <div className="solutions-card">
                <div className="solution-image">
                  <img src={SolutionsOne} alt="Global Manufacturing" />
                  <div className="image-overlay-card"></div>
                </div>
                <div className="solution-content">
                  <h4 className="solution-card-header">
                    Scale with Global Manufacturing
                  </h4>
                  <p className="solution-card-writings">
                    Our European facility combines FDA-grade quality with
                    cost-efficient scalability, giving OEMs the confidence to
                    move from prototype to production without compromise.
                  </p>
                  <div className="solution-features">
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>FDA and CE compliant facilities</span>
                    </div>
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>Scalable production lines</span>
                    </div>
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>Cost-efficient manufacturing</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="solutions-card">
                <div className="solution-image">
                  <img src={SolutionsTwo} alt="Structured Momentum" />
                  <div className="image-overlay-card"></div>
                </div>
                <div className="solution-content">
                  <h4 className="solution-card-header">
                    Unblock Projects with Structured Momentum
                  </h4>
                  <p className="solution-card-writings">
                    The Design-to-Prototype Sprint is a low-risk, fixed-scope
                    engagement that helps OEMs trial Medichy, accelerate stalled
                    projects, and move quickly from concept to manufacturable
                    prototype.
                  </p>
                  <div className="solution-features">
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>Fixed-scope, low-risk engagement</span>
                    </div>
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>Accelerated prototype development</span>
                    </div>
                    <div className="feature">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span>Seamless integration with existing teams</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="solutions-cta">
              <button className="btn-primary" onClick={handleTalkToTeam}>
                EXPLORE OEM SOLUTIONS
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="built-to-scale-section">
            <div className="section-header">
              <h3>Built to scale with OEMs</h3>
              <p className="section-subtitle">
                We act as an extension of your R&D team, integrating seamlessly
                into your process to accelerate projects and scale production.
              </p>
            </div>

            <div className="scale-features">
              <div className="feature-grid">
                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <GiServerRack className="feature-icon" />
                  </div>
                  <h4>Align with your R&D needs</h4>
                  <p>
                    Seamless integration with your existing R&D processes and
                    teams for maximum efficiency.
                  </p>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <IoIosTimer className="feature-icon" />
                  </div>
                  <h4>Accelerate stalled projects</h4>
                  <p>
                    Get projects back on track with our structured approach and
                    proven methodologies.
                  </p>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <HiOutlinePuzzlePiece className="feature-icon" />
                  </div>
                  <h4>Ensure compliance at every stage</h4>
                  <p>
                    Built-in regulatory expertise ensures compliance from
                    concept through production.
                  </p>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <ImCompass className="feature-icon" />
                  </div>
                  <h4>Scale with global facilities</h4>
                  <p>
                    Access to international manufacturing facilities for
                    cost-effective scaling.
                  </p>
                </div>
              </div>
            </div>

            <div className="cta-container">
              <div className="cta-content">
                <h3>Ready to scale your medical device manufacturing?</h3>
                <p>
                  Partner with Medichy for end-to-end solutions that combine
                  regulatory expertise with scalable production capabilities.
                </p>
                <button className="btn-primary" onClick={handleTalkToTeam}>
                  START PARTNERSHIP
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </TheOEM>
    </>
  );
};

const TheOEM = styled.div`
  width: 100%;
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .contact-hero-section {
    position: relative;
    height: 70vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 4rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2rem;
        line-height: 1.6;
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto 2rem;
    }
  }

  .early-stage {
    padding: 4rem 0;

    .imagery-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
      margin-top: 3rem;
    }

    .imagery-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }
    }

    .imagery-content {
      .content-item {
        display: flex;
        align-items: flex-start;
        gap: 1.5rem;
        margin-bottom: 2.5rem;
        padding: 1.5rem;
        border-radius: 12px;
        background: #f8fafc;
        transition: all 0.3s ease;

        &:hover {
          background: #edf2f7;
          transform: translateX(10px);
        }

        &:last-child {
          margin-bottom: 0;
        }

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          .icon {
            color: white;
            font-size: 1.75rem;
          }
        }

        .item-text {
          h4 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 0.5rem;
          }

          p {
            font-size: 1rem;
            color: #666;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .solutions-section {
    padding: 6rem 0;
    background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);
    border-radius: 24px;
    margin: 4rem 0;

    .solutions-cards {
      display: grid;
      grid-template-columns: 1fr;
      gap: 3rem;
      max-width: 800px;
      margin: 0 auto;
    }

    .solutions-card {
      background: white;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
      }

      .solution-image {
        position: relative;
        height: 250px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .image-overlay-card {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.1),
            rgba(0, 100, 200, 0.2)
          );
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .solution-content {
        padding: 2.5rem;

        .solution-card-header {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1rem;
          line-height: 1.3;
        }

        .solution-card-writings {
          font-size: 1.1rem;
          color: #666;
          line-height: 1.6;
          margin-bottom: 2rem;
        }

        .solution-features {
          .feature {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            margin-bottom: 0.75rem;
            color: #4a5568;
            font-size: 1rem;

            &:last-child {
              margin-bottom: 0;
            }

            svg {
              color: #3182ce;
              flex-shrink: 0;
            }
          }
        }
      }
    }

    .solutions-cta {
      text-align: center;
      margin-top: 3rem;

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
        color: white;
        border: none;
        padding: 1.25rem 3rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  .built-to-scale-section {
    padding: 4rem 0;

    .scale-features {
      margin: 3rem 0;

      .feature-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;

        .feature-card {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          text-align: center;

          &:hover {
            transform: translateY(-8px);
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
          }

          .feature-icon-wrapper {
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1.5rem;

            .feature-icon {
              color: white;
              font-size: 2rem;
            }
          }

          h4 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 1rem;
          }

          p {
            font-size: 1rem;
            color: #666;
            line-height: 1.5;
          }
        }
      }
    }

    .cta-container {
      background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
      border-radius: 24px;
      padding: 4rem;
      text-align: center;
      color: white;
      margin-top: 4rem;

      .cta-content {
        max-width: 700px;
        margin: 0 auto;

        h3 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1.25rem;
          opacity: 0.95;
          margin-bottom: 2.5rem;
          line-height: 1.6;
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: white;
          color: #3182ce;
          border: none;
          padding: 1.25rem 3rem;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:hover {
            background: #f7fafc;
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);

            svg {
              transform: translateX(5px);
            }
          }

          svg {
            color: #3182ce;
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    .contact-hero-section {
      height: 65vh;

      .hero-content {
        h3 {
          font-size: 3.25rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .contact-hero-section {
      height: 60vh;

      .hero-content {
        h3 {
          font-size: 3rem;
        }
      }
    }

    .early-stage {
      .imagery-container {
        gap: 3rem;
      }

      .imagery-image {
        height: 350px;
      }
    }

    .built-to-scale-section {
      .feature-grid {
        grid-template-columns: 1fr;
        max-width: 500px;
        margin: 0 auto;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .contact-hero-section {
      height: 55vh;
      margin-bottom: 3rem;

      .hero-content {
        h3 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }

    .early-stage {
      padding: 3rem 0;

      .imagery-container {
        grid-template-columns: 1fr;
        gap: 3rem;
      }

      .imagery-image {
        height: 300px;
        order: 2;
      }

      .imagery-content {
        order: 1;
      }
    }

    .solutions-section {
      padding: 4rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .solutions-cards {
        gap: 2rem;
      }

      .solutions-card {
        .solution-content {
          padding: 2rem;
        }
      }

      .solutions-cta {
        .btn-primary {
          padding: 1rem 2.5rem;
          font-size: 1rem;
        }
      }
    }

    .built-to-scale-section {
      padding: 3rem 0;

      .cta-container {
        padding: 3rem 2rem;
        margin-top: 3rem;

        .cta-content {
          h3 {
            font-size: 2rem;
          }

          p {
            font-size: 1.1rem;
          }

          .btn-primary {
            padding: 1rem 2.5rem;
            font-size: 1rem;
          }
        }
      }
    }

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .early-stage {
      padding: 2.5rem 0;

      .imagery-image {
        height: 250px;
      }

      .imagery-content {
        .content-item {
          flex-direction: column;
          text-align: center;
          gap: 1rem;
          padding: 1.25rem;

          .icon-wrapper {
            margin: 0 auto;
          }

          &:hover {
            transform: translateY(-5px);
          }
        }
      }
    }

    .solutions-section {
      padding: 3rem 0;
      margin: 2.5rem 0;

      .solutions-card {
        .solution-image {
          height: 200px;
        }

        .solution-content {
          padding: 1.5rem;

          .solution-card-header {
            font-size: 1.25rem;
          }

          .solution-card-writings {
            font-size: 1rem;
          }
        }
      }
    }

    .built-to-scale-section {
      padding: 2.5rem 0;

      .feature-grid {
        .feature-card {
          padding: 1.5rem;

          .feature-icon-wrapper {
            width: 60px;
            height: 60px;

            .feature-icon {
              font-size: 1.5rem;
            }
          }

          h4 {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.95rem;
          }
        }
      }

      .cta-container {
        padding: 2.5rem 1.5rem;
        margin-top: 2.5rem;

        .cta-content {
          h3 {
            font-size: 1.75rem;
          }

          p {
            font-size: 1rem;
            margin-bottom: 2rem;
          }

          .btn-primary {
            padding: 0.875rem 2rem;
            font-size: 0.95rem;
          }
        }
      }
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-secondary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }

    .early-stage {
      padding: 2rem 0;

      .imagery-image {
        height: 200px;
      }

      .imagery-content {
        .content-item {
          padding: 1rem;
          margin-bottom: 1.5rem;

          .icon-wrapper {
            width: 50px;
            height: 50px;

            .icon {
              font-size: 1.5rem;
            }
          }

          .item-text {
            h4 {
              font-size: 1.1rem;
            }

            p {
              font-size: 0.9rem;
            }
          }
        }
      }
    }

    .solutions-section {
      padding: 2.5rem 0.75rem;
      margin: 2rem 0;

      .solutions-card {
        .solution-image {
          height: 180px;
        }

        .solution-content {
          padding: 1.25rem;

          .solution-card-header {
            font-size: 1.1rem;
          }

          .solution-card-writings {
            font-size: 0.95rem;
          }
        }
      }
    }

    .built-to-scale-section {
      padding: 2rem 0;

      .feature-grid {
        .feature-card {
          padding: 1.25rem;

          .feature-icon-wrapper {
            width: 50px;
            height: 50px;

            .feature-icon {
              font-size: 1.25rem;
            }
          }

          h4 {
            font-size: 1rem;
          }

          p {
            font-size: 0.9rem;
          }
        }
      }

      .cta-container {
        padding: 2rem 1rem;
        margin-top: 2rem;

        .cta-content {
          h3 {
            font-size: 1.5rem;
          }

          p {
            font-size: 0.9rem;
          }

          .btn-primary {
            padding: 0.75rem 1.5rem;
            font-size: 0.9rem;
          }
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-secondary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .container {
      padding: 0 0.5rem;
    }

    .early-stage {
      .imagery-image {
        height: 180px;
      }

      .imagery-content {
        .content-item {
          .icon-wrapper {
            width: 45px;
            height: 45px;

            .icon {
              font-size: 1.25rem;
            }
          }

          .item-text {
            h4 {
              font-size: 1rem;
            }

            p {
              font-size: 0.85rem;
            }
          }
        }
      }
    }

    .solutions-section {
      .solutions-card {
        .solution-content {
          padding: 1rem;

          .solution-card-header {
            font-size: 1rem;
          }

          .solution-card-writings {
            font-size: 0.9rem;
          }
        }
      }
    }

    .built-to-scale-section {
      .feature-grid {
        .feature-card {
          padding: 1rem;

          .feature-icon-wrapper {
            width: 45px;
            height: 45px;

            .feature-icon {
              font-size: 1.1rem;
            }
          }

          h4 {
            font-size: 0.95rem;
          }

          p {
            font-size: 0.85rem;
          }
        }
      }

      .cta-container {
        .cta-content {
          h3 {
            font-size: 1.25rem;
          }

          p {
            font-size: 0.85rem;
          }

          .btn-primary {
            padding: 0.625rem 1.25rem;
            font-size: 0.85rem;

            svg {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }
    }
  }
`;

export default OEMs;
